<template>
  <v-list-tile
    @click="routerPush()"
    v-if="getShowFlg()"
    v-bind:class="{ selected: isSelected() }"
  >
    <v-list-tile-content>
      <v-list-tile-title :style="vListTileTitleStyle"
        >{{ name }}<slot
      /></v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: 'DrawerMenuItem',
  props: {
    path: String,
    name: String,
    selectedMenu: String,
    children: Boolean,
  },
  computed: {
    vListTileTitleStyle() {
      return this.children ? { marginLeft: '10px' } : {}
    },
  },
  methods: {
    routerPush() {
      this.$router.push(this.path).catch(() => {})
    },
    getShowFlg() {
      return this.$store.getters['drawerUriAuths/getShowFlg'](this.path)
    },
    isSelected() {
      if (this.selectedMenu !== this.path) return false
      return true
    },
  },
}
</script>

<style scoped>
.selected {
  background-color: lightcyan;
}
</style>
